<script setup>
import {ref, onUpdated} from  "vue"
import Header from '@/components/Header/index.vue'
import Menu from '@/components/Menu/index.vue'
import {getRoute} from "@/hooks/getRoute.js"

const {route} = getRoute()
const bread = ref(route.meta.bread)
onUpdated(() => {
  bread.value = route.meta.bread
})
</script>

<template>
  <div class="full_v flex_align_t">
    <div style="height: 100vh">
      <Menu :bread="bread" />
    </div>
    <div class="content_box">
      <div class="header_box">
        <Header :bread="bread"/>
      </div>
      <div class="main_box">
        <router-view/>
      </div>
    </div>
  </div>
  <el-backtop :target="'.main_box'" :bottom="100">
    <v-btn icon="mdi-arrow-collapse-up" color="#1a1a1a" variant="flat" size="small"></v-btn>
  </el-backtop>
</template>

<style scoped>
::v-deep(.v-data-table-column--fixed) {
  right: 0;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}
::v-deep(.v-data-table__tr) {
  text-align: left;
}
</style>